import React, { Component } from 'react';
import { safeParse } from '../utils';
import { ChevronIcon2 } from './SVGIcons';

// Обёртка над html-react-parser: не падает на пустом/undefined значении
// (раньше SSR бросал TypeError и вся страница отдавала 503 «Технические работы»)
const Parser = safeParse;

class App extends Component {
  
  // Функция для рендера списка из строки с разделителем ||
  renderList(listString) {
    if (!listString) return null;
    
    const items = listString.split('||');
    return items.map((item, index) => (
      <div key={index} className='flex items-start gap-[7px] mt-[10px] first:mt-0'>
        <svg className='flex-none mt-[5px]' width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="3" cy="3" r="3" fill="#009EE3"/>
        </svg>
        <div>{item}</div>
      </div>
    ));
  }

  // Функция для выбора иконки по номеру
  renderIcon(iconNumber) {
    switch(iconNumber) {
      case '1':
        return (
          <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 13.4V16.4C17 20.4 15.4 22 11.4 22H7.6C3.6 22 2 20.4 2 16.4V12.6C2 8.6 3.6 7 7.6 7H10.6" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16.9996 13.4H13.7996C11.3996 13.4 10.5996 12.6 10.5996 10.2V7L16.9996 13.4Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.5996 2H15.5996" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7 5C7 3.34 8.34 2 10 2H12.62" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22.0004 8V14.19C22.0004 15.74 20.7404 17 19.1904 17" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M22 8H19C16.75 8 16 7.25 16 5V2L22 8Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        );
      case '2':
        return (
          <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.48047 18.35L10.5805 20.75C10.9805 21.15 11.8805 21.35 12.4805 21.35H16.2805C17.4805 21.35 18.7805 20.45 19.0805 19.25L21.4805 11.95C21.9805 10.55 21.0805 9.34997 19.5805 9.34997H15.5805C14.9805 9.34997 14.4805 8.84997 14.5805 8.14997L15.0805 4.94997C15.2805 4.04997 14.6805 3.04997 13.7805 2.74997C12.9805 2.44997 11.9805 2.84997 11.5805 3.44997L7.48047 9.54997" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
            <path d="M2.37988 18.3499V8.5499C2.37988 7.1499 2.97988 6.6499 4.37988 6.6499H5.37988C6.77988 6.6499 7.37988 7.1499 7.37988 8.5499V18.3499C7.37988 19.7499 6.77988 20.2499 5.37988 20.2499H4.37988C2.97988 20.2499 2.37988 19.7499 2.37988 18.3499Z" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        );
      case '3':
        return (
          <svg className='flex-none' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.30957 14.7002L10.8096 16.2002L14.8096 12.2002" stroke="#009EE3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 6H14C16 6 16 5 16 4C16 2 15 2 14 2H10C9 2 8 2 8 4C8 6 9 6 10 6Z" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M16 4.02002C19.33 4.20002 21 5.43002 21 10V16C21 20 20 22 15 22H9C4 22 3 20 3 16V10C3 5.44002 4.67 4.20002 8 4.02002" stroke="#009EE3" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        );
      case '4':
        return (
          <svg className='flex-none' width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.14481 1.24637C2.09095 0.235039 3.5785 0 5.47 0H13.03C14.9212 0 16.4094 0.234907 17.3544 1.24685C18.2828 2.24101 18.4949 3.78799 18.49 5.79109C18.49 5.79083 18.49 5.79135 18.49 5.79109V17.06C18.49 17.7849 18.3923 18.4269 18.1806 18.9486C17.9678 19.4728 17.6162 19.9264 17.0897 20.1536C16.5578 20.3832 15.9882 20.3212 15.4686 20.0971C14.9563 19.8762 14.4502 19.4832 13.9627 18.9628L13.9613 18.9613C13.6923 18.6726 13.3863 18.5693 13.1183 18.5839C12.85 18.5985 12.5564 18.7348 12.32 19.05L11.3105 20.3993L11.308 20.4027C10.7827 21.0966 10.0433 21.5025 9.245 21.5025C8.4467 21.5025 7.70733 21.0966 7.18202 20.4027L7.17947 20.3993L6.17 19.05C5.9336 18.7348 5.64003 18.5985 5.37172 18.5839C5.10374 18.5693 4.79771 18.6726 4.52871 18.9613L4.52742 18.9627C4.04203 19.481 3.53697 19.8728 3.02494 20.093C2.50572 20.3164 1.93637 20.3779 1.40457 20.1488C0.877949 19.922 0.525032 19.469 0.31116 18.9438C0.0983381 18.4211 0 17.7776 0 17.05V5.79C0 3.78644 0.215319 2.2399 1.14481 1.24637ZM2.24019 2.27113C1.75468 2.7901 1.5 3.76356 1.5 5.79V17.05C1.5 17.6574 1.58416 18.0926 1.7004 18.3781C1.81559 18.661 1.9383 18.7455 1.99793 18.7712C2.05238 18.7946 2.1799 18.8236 2.43225 18.7151C2.69178 18.6035 3.03297 18.364 3.43258 17.9373L3.98 18.45L3.43129 17.9387C3.98229 17.3474 4.71126 17.0457 5.45328 17.0861C6.19497 17.1265 6.8864 17.5052 7.37 18.15L8.37798 19.4973C8.37836 19.4978 8.37874 19.4983 8.37911 19.4988C8.66352 19.8737 8.98365 20.0025 9.245 20.0025C9.50636 20.0025 9.82651 19.8737 10.1109 19.4988C10.1113 19.4983 10.1117 19.4978 10.112 19.4973L11.1195 18.1507C11.6031 17.5059 12.295 17.1265 13.0367 17.0861C13.7783 17.0457 14.5069 17.3471 15.0578 17.9377C15.46 18.367 15.8025 18.6076 16.0626 18.7197C16.3155 18.8288 16.4422 18.7993 16.4953 18.7764C16.5538 18.7511 16.6759 18.6672 16.7907 18.3845C16.9064 18.0994 16.99 17.6651 16.99 17.06V5.79L16.99 5.78814C16.995 3.76161 16.7421 2.78886 16.2581 2.27065C15.7906 1.77009 14.9188 1.5 13.03 1.5H5.47C3.5815 1.5 2.70905 1.76996 2.24019 2.27113Z" fill="#009EE3"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 5.75C4.5 5.33579 4.83579 5 5.25 5H13.25C13.6642 5 14 5.33579 14 5.75C14 6.16421 13.6642 6.5 13.25 6.5H5.25C4.83579 6.5 4.5 6.16421 4.5 5.75Z" fill="#009EE3"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.5 9.75C5.5 9.33579 5.83579 9 6.25 9H12.25C12.6642 9 13 9.33579 13 9.75C13 10.1642 12.6642 10.5 12.25 10.5H6.25C5.83579 10.5 5.5 10.1642 5.5 9.75Z" fill="#009EE3"/>
          </svg>
        );
      default:
        return null;
    }
  }

  // Функция для рендера карточки в зависимости от типа v
  renderCard(card, index) {
    const { v, title, text, list, image, icon } = card;
    const { data, showWindow } = this.props;
    
    // Карточка типа 3 (специальная)
    if (v === '3') {
      return (
        <div key={index} className='flex-1 xl:min-h-[181px] rounded-[15px] p-[20px]'
          style={{
            backgroundImage: `url("${image || 'src/images/trusr_card4_bg.png'}")`,
            backgroundSize: 'cover'
          }}
        >
          <div className='flex justify-between items-start'>
            <h3 className='font-medium text-[24px] xl:text-[36px] text-white leading-none'>{Parser(title)}</h3>
            {data?.slogo && (
              <img className='hidden xl:block' src={data.slogo} width={50} height={50} alt='logo' />
            )}
          </div>
          <div className='flex justify-between items-center mt-[10px] gap-[26px]'>
            <div className='text-white/60 text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(text)}</div>
            <div onClick={() => showWindow()} className='hidden xl:flex items-center gap-[9px] h-[50px] px-[19px] bg-white text-black rounded-full cursor-pointer whitespace-nowrap'>
              <div>Связаться с менеджером</div>
              <ChevronIcon2 stroke="black" />
            </div>
          </div>
          <div className='flex xl:hidden gap-[10px] items-center w-full mt-[20px]'>
            <div onClick={() => showWindow()} className='flex text-[12px] items-center gap-[9px] h-[38px] justify-center flex-1 bg-white text-black rounded-full cursor-pointer whitespace-nowrap'>
              <div>Связаться</div>
              <ChevronIcon2 stroke="black" />
            </div>
            <img className='block' src={data?.slogo} width={38} height={38} alt='logo' />
          </div>
        </div>
      );
    }
    
    // Карточка типа 2 (с темным фоном)
    if (v === '2') {
      return (
        <div key={index} className='w-full xl:w-[528px] xl:min-h-[285px] rounded-[15px] p-[20px] bg-[#032432] bg-right-bottom bg-no-repeat'
          style={{
            backgroundImage: image ? `url("${image}")` : 'none'
          }}
        >
          <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[33px] w-full'>
            {this.renderIcon(icon)}
            <div className='text-[16px] xl:text-[18px] text-white'>{Parser(title)}</div>
          </div>
          <div className='mt-[10px] text-white/60 text-[14px]'>{Parser(text)}</div>
          {list && (
            <div className='mt-[15px] rounded-[15px] bg-white px-[15px] py-[18px] text-[14px] xl:text-[16px] tracking-[-0.02em] text-black/60'>
              {this.renderList(list)}
            </div>
          )}
        </div>
      );
    }
    
    // Карточка типа 1 (стандартная)
    // Для 4-й карточки (индекс 3) ограничиваем высоту и делаем компактнее
    const isFourthCard = index === 3;
    
    if (isFourthCard) {
      return (
        <div 
          key={index} 
          className='w-full xl:w-[316px] rounded-[15px] bg-[#F5F7F9] p-[20px] pr-[10px]'
        >
          <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[26px] w-full'>
            {this.renderIcon(icon)}
            <div className='text-[16px] xl:text-[18px] text-[#032432]'>
              {Parser(title)}
            </div>
          </div>
          <div className='text-black/60 mt-[10px] text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(text)}</div>
        </div>
      );
    }
    
    // Остальные карточки типа 1
    return (
      <div 
        key={index} 
        className={`
          ${index === 0 ? 'w-full xl:w-[316px]' : 'flex-1'} 
          xl:min-h-[285px] 
          rounded-[15px] 
          bg-[#F5F7F9] 
          p-[20px] 
          pr-[10px]
        `}
      >
        <div className='flex flex-row-reverse xl:flex-col justify-between items-start gap-[33px] w-full'>
          {this.renderIcon(icon)}
          <div className='text-[16px] xl:text-[18px] text-[#032432]'>
            {Parser(title)}
          </div>
        </div>
        <div className='text-black/60 mt-[10px] text-[14px] xl:text-[16px] tracking-[-0.02em]'>{Parser(text)}</div>
        {list && (
          <div className='mt-[15px] rounded-[15px] bg-white px-[15px] py-[18px] text-[14px] xl:text-[16px] tracking-[-0.02em] text-black/60'>
            {this.renderList(list)}
          </div>
        )}
      </div>
    );
  }

  render() {
    const { data } = this.props;
    const { block_gos } = data;

    if (!block_gos || !block_gos.cards) {
      return null;
    }

    // Разделяем карточки на две строки
    const firstRowCards = block_gos.cards.slice(0, 3);
    const secondRowCards = block_gos.cards.slice(3, 5);

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        <div className='container'>
          <div className='flex justify-center xl:justify-start items-center gap-[10px] text-[14px] xl:text-[16px] tracking-[-0.02em]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.75 16.5H3.75C2.25 16.5 1.5 15.75 1.5 14.25V8.25C1.5 6.75 2.25 6 3.75 6H7.5V14.25C7.5 15.75 8.25 16.5 9.75 16.5Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.58249 3C7.52249 3.225 7.5 3.4725 7.5 3.75V6H3.75V4.5C3.75 3.675 4.425 3 5.25 3H7.58249Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.5 6V9.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13.5 6V9.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.75 12.75H11.25C10.8375 12.75 10.5 13.0875 10.5 13.5V16.5H13.5V13.5C13.5 13.0875 13.1625 12.75 12.75 12.75Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.5 9.75V12.75" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.5 14.25V3.75C7.5 2.25 8.25 1.5 9.75 1.5H14.25C15.75 1.5 16.5 2.25 16.5 3.75V14.25C16.5 15.75 15.75 16.5 14.25 16.5H9.75C8.25 16.5 7.5 15.75 7.5 14.25Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>Взаимодействие с государством</div>
            </div>
          </div>
          
          <h2 className='font-medium mt-[20px] xl:mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(block_gos?.title)}</h2>
          <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60'>{Parser(block_gos?.text)}</div>
          
          {/* Первая строка карточек */}
          <div className='flex flex-col xl:flex-row items-stretch gap-[10px] mt-[30px]'>
            {firstRowCards.map((card, index) => this.renderCard(card, index))}
          </div>
          
          {/* Вторая строка карточек */}
          {secondRowCards.length > 0 && (
            <div className='flex flex-col xl:flex-row items-stretch gap-[10px] mt-[10px]'>
              {secondRowCards.map((card, index) => this.renderCard(card, index + 3))}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default App;